import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import toPlainText from 'utils/mention-to-plaintext';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import LensIcon from '@material-ui/icons/Lens';
import { ROLES } from 'constant/userTypes';
import { getFullName, getInitials, toUserTimezone } from 'utils';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import stc from 'string-to-color';

const COLORS = {
  coaches: '#3097F3',
  admin: '#e9c65a',
  parents_coaches: '#8add72',
  parents_admin: '#e02e2e',
};

const displayTransform = (id, display) => '@' + display;

export const getRoomName = ({ room, room_name }, role) => {
  const name = getFullName(room.student);

  switch (room_name) {
    case 'coaches': {
      if (role === ROLES.ADMIN) {
        return `${name} - Student Team `;
      }
      return `${name}`;
    }
    case 'admin': {
      return `${name} - Student Admin`;
    }
    case 'parents_coaches': {
      if (role === ROLES.PARENT) {
        return `${room.student.user_first_name}'s Counseling Team`;
      } else if (role === ROLES.ADMIN) {
        return `${name} - Parent Team`;
      }
      return `${name}'s Parents`;
    }
    case 'parents_fa': {
      if (role === ROLES.PARENT) {
        return `${name}'s Financial Aid Counselor`;  //Added Full name of the student
      }
      return `${name}- Parent Financial Aid`;       //Added Full name of the student
    }
    case 'parents_admin': {
      if (role === ROLES.PARENT) {
        return `${room.student.user_first_name}'s Admin`;
      }
      return `${name} - Parent Admin`;
    }
    default:
      return room_name;
  }
};

const getRoomIcon = (name) => {
  switch (name) {
    case 'parents_admin':
    case 'parents_coaches':
      return PeopleOutlineIcon;
    case 'admin':
    case 'coaches':
      return PersonOutlineIcon;
    default:
      return PeopleOutlineIcon;
  }
};

const ChatListItem = ({ user, room, selected, classes }) => {
  const Icon = getRoomIcon(room.room_name);
  const isGroup = room.room_name === 'groups';
  const msg = toPlainText(room.message || room.last_message, displayTransform);

  return (
    <ListItem
      button
      divider
      component={Link}
      className={classes.listItem}
      selected={selected}
      to={
        !isGroup
          ? `/inbox/messages/${room.id}`
          : `/groups/messages/${room.id}`
      }
    >
      <ListItemAvatar>
        <Avatar
          className={classes.roomIcon}
          style={{ backgroundColor: !isGroup ? COLORS[room.room_name] : stc(room.room.group?.name) }}
        >
          {!isGroup ? (
            <Icon />
          ) : (
            getInitials(room.room.group?.name)
          )}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primaryTypographyProps={{
          className: classes.roomName,
        }}
        primary={!isGroup ? getRoomName(room, user.type) : room.room.group?.name}
        secondary={room.last_message_at ? `${toUserTimezone(room.last_message_at, user.timezone).format('DD-MM-YY h:mm A')} - ` + (msg.length ? msg : 'No message text') : null}
        secondaryTypographyProps={{
          className: classes.message,
          color: 'textPrimary',
          style: {
            fontWeight: room.unread ? 500 : 400,
            color: room.unread && '#000',
          },
        }}
      />
      {room.unread && (
        <ListItemSecondaryAction>
          <LensIcon color="primary" className={classes.unreadDot} />
        </ListItemSecondaryAction>
      )}
    </ListItem>
  );
};

export default ChatListItem;
